import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-slate-900/30 mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <p className="text-center text-xs text-slate-500">
          © Jigsaw Conferences Ltd. All rights reserved. |{" "}
          <Link to="/legal/terms" className="hover:text-white transition-colors">
            Terms
          </Link>{" "}
          |{" "}
          <Link to="/legal/privacy" className="hover:text-white transition-colors">
            Privacy
          </Link>{" "}
          |{" "}
          <Link to="/legal/cookies" className="hover:text-white transition-colors">
            Cookies
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
